import { createContext } from "react"

export const AppUIContext = createContext()
